import { useState, useEffect } from 'react'
import { dispatchSocket } from '@/utils/socket'
import type { DispatchEmitPayload } from '@/types'

export const useSocketConnection = () => {
  const [isConnected, setIsConnected] = useState(false)
  const [connectionError, setConnectionError] = useState<string | null>(null)

  useEffect(() => {
    try {
      dispatchSocket.connect()
    } catch (error) {
      console.warn('Erreur de connexion socket:', error)
      setConnectionError('Impossible de se connecter au serveur')
    }

    const unsubConnect = dispatchSocket.on('connect', () => {
      setIsConnected(true)
      setConnectionError(null)
    })

    const unsubDisconnect = dispatchSocket.on('disconnect', () => {
      setIsConnected(false)
    })

    const unsubError = dispatchSocket.on<Error>('connect_error', (error) => {
      console.error('Erreur de connexion socket:', error)
      const msg = error?.message
      setConnectionError(msg ?? 'Erreur de connexion')
      setIsConnected(false)
    })

    return () => {
      unsubConnect()
      unsubDisconnect()
      unsubError()
      dispatchSocket.disconnect()
    }
  }, [])

  return {
    isConnected,
    connectionError,
  }
}

export const useSocketEmit = () => {
  const { isConnected } = useSocketConnection()

  const emitDispatchUpdate = (data: DispatchEmitPayload) => {
    if (isConnected) {
      dispatchSocket.emit('dispatchUpdate', data)
    } else {
      console.warn('Socket non connecté - impossible d\'émettre dispatch update')
    }
  }

  const emitEmployeeUpdate = (data: { employeeId: number; changes: Record<string, unknown>; updatedBy?: string }) => {
    if (isConnected) {
      dispatchSocket.emit('dispatchUpdate', { type: 'employee_update', data })
    } else {
      console.warn('Socket non connecté - impossible d\'émettre employee update')
    }
  }

  return {
    emitDispatchUpdate,
    emitEmployeeUpdate,
  }
}
